import {decode as base64_decode, encode as base64_encode} from 'base-64';
import { postApi,baseURL} from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import { message } from "antd";
import config from "../config";



class IdleReportStore {
  idleReport=[]
  totalIdleArray=[]
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
        idleReport: observable,
        totalIdleArray:observable,
      total:observable,
      loading:observable,
      loadData:action,
      exportExcel:action,
      exportcsv:action,
      exportpdf:action,
      exportxml:action,
      totalIdleReport:action,

     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({companyId,offset,limit,vehicleId,fromDate,toDate,interval,pageNo}) {

    this.loading=true
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,"interval":interval,"offset":offset,"limit":limit,"page":pageNo}
    
    if (config.pythonReport === 1) {

      var response = await postApi.getClient("report").post("/tracking_report/idle", postData);

    } else {

        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicleidle&a=idlingreport", "postData="+base64Input);
    }

    this.idleReport =response?.data?.data?.idlingReport
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;

  }


  async totalIdleReport({offset,limit,companyId,fromDate,toDate,vehicleId,interval}) {

    this.loadingData=true
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,interval:interval,offset:offset,limit:limit,total: true}
    
    if (config.pythonReport == 1) { 
        var response = await postApi.getClient("report").post("/tracking_report/idle", postData);
        this.totalIdleArray = response?.data?.data?.idlingReport;
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=totalIdleRep", "postData="+base64Input);   
        this.totalIdleArray = response?.data?.data
    }

    this.loadingData=false;
  }


  async exportExcel(getData) {

    if (config.pythonReport === 1) {

      
      
      try {

          const res = await postApi.getClient("report").post("/tracking_report/idle/download/excel", getData, {
            responseType: "blob",
          });

          this.pythonReportMessage = true;
      } catch (error) {
          this.pythonReportErrorMessage = true;
          message.error("Failed to download the report. Please try again.");
      }

    } else {
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicleidle&a=exportidleexcel&cid=" +
          getData.companyId+
          "&userId=" +
          getData.userId+
          "&vid=" +
          getData.vehicleId+
          "&int="+
          getData.interval+
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      
      
      try {
       
          await postApi.getClient("report").post("/tracking_report/idle/download/pdf", getData, {
            responseType: "blob",
          });

         this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }

    } else {
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicleidle&a=exportidlepdf&cid=" +
          getData.companyId+
          "&userId=" +
          getData.userId+
          "&vid=" +
          getData.vehicleId+
          "&int="+
          getData.interval+
          "&fD=" +
          getData.fromDate+
          "&tD=" +
          getData.toDate+
          "&colList=" +
          getData.colList+
          "&language=" +
          lang;
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportidlecsv&cid=" +
      getData.companyId +
      "&userId=" +
     getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&int="+
      getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportidlexml&cid=" +
      getData.companyId +
      " &userId=" +
     getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&int="+
      getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  
  

}

export default IdleReportStore;
